export default __webpack_public_path__ + "static/media/14473_Atrium_E1_Insel5_1_roteTafel_1000x2480mm_RZ.5cfd9536.pdf";